"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

var _paymentTypes = require("../data/payment-types");

var _default = function _default(_ref) {
  var flag = _ref.flag,
      title = _ref.title,
      blurb = _ref.blurb,
      pricing = _ref.pricing,
      qualitiesTitle = _ref.qualitiesTitle,
      listOfQualities = _ref.listOfQualities,
      onPlanSelected = _ref.onPlanSelected,
      index = _ref.index;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: flag ? 'green-outline' : ''
  }, flag ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "payment-card-emphasis centered-content header-text"
  }, flag) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "payment-card-emphasis-empty"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "payment-card"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "payment-card-title header-text ".concat(flag ? 'squared-top-radius' : '')
  }, /*#__PURE__*/_react["default"].createElement("h2", null, title), /*#__PURE__*/_react["default"].createElement("p", {
    className: "payment-card-blurb"
  }, blurb)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "payment-card-description"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    dangerouslySetInnerHTML: {
      __html: pricing.description
    }
  }), /*#__PURE__*/_react["default"].createElement("p", null, pricing.subdescription)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "payment-card-items"
  }, /*#__PURE__*/_react["default"].createElement("h3", null, qualitiesTitle), listOfQualities.map(function (quality) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "payment-card-item body-text",
      key: quality
    }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Icon, {
      size: "large",
      name: "check",
      className: "payment-card-item-icon"
    }), /*#__PURE__*/_react["default"].createElement("p", null, quality));
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "payment-card-cta"
  }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Button, {
    className: "select",
    onClick: function onClick() {
      return onPlanSelected(index);
    }
  }, index === _paymentTypes.CUSTOM_PLAN_INDEX ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Call Sales") : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Preview for Free")))));
};

exports["default"] = _default;